// Generated by ReScript, PLEASE EDIT WITH CARE

import * as AdjustFareEntityMapper from "../entity-mapper/AdjustFareEntityMapper.bs.js";
import * as ResponseHandler$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.bs.js";
import * as IncidentalChargeEntityMapper from "../entity-mapper/IncidentalChargeEntityMapper.bs.js";
import * as PreviewAdjustFareEntityMapper from "../entity-mapper/PreviewAdjustFareEntityMapper.bs.js";
import * as SuccessWithNoContentEntityMapper from "../../../edit-order/app/entity-mapper/SuccessWithNoContentEntityMapper.bs.js";

var execute = AdjustFareEntityMapper.execute;

var AdjustFareResponseConverterConfig = {
  execute: execute
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var AdjustFareResponseConverter = partial_arg(AdjustFareResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$1 = PreviewAdjustFareEntityMapper.execute;

var PreviewAdjustFareResponseConverterConfig = {
  execute: execute$1
};

var partial_arg$1 = ResponseHandler$Catalyst.ResponseConverter;

var PreviewAdjustFareResponseConverter = partial_arg$1(PreviewAdjustFareResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$2 = SuccessWithNoContentEntityMapper.execute;

var UpdateAdjustFareResponseConverterConfig = {
  execute: execute$2
};

var partial_arg$2 = ResponseHandler$Catalyst.ResponseConverter;

var UpdateAdjustFareResponseConverter = partial_arg$2(UpdateAdjustFareResponseConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

var execute$3 = IncidentalChargeEntityMapper.execute;

var IncidentalChargeTypeConverterConfig = {
  execute: execute$3
};

var partial_arg$3 = ResponseHandler$Catalyst.ResponseConverter;

var IncidentalChargeTypeResponseConverter = partial_arg$3(IncidentalChargeTypeConverterConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  AdjustFareResponseConverterConfig ,
  AdjustFareResponseConverter ,
  PreviewAdjustFareResponseConverterConfig ,
  PreviewAdjustFareResponseConverter ,
  UpdateAdjustFareResponseConverterConfig ,
  UpdateAdjustFareResponseConverter ,
  IncidentalChargeTypeConverterConfig ,
  IncidentalChargeTypeResponseConverter ,
  
}
/* AdjustFareResponseConverter Not a pure module */
